import {UserService} from '../../../services/user.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Component, Inject, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {RequestsHandler} from '../../../services/requests.service';
import {DialogSharedComponent} from '../../dialog-shared/dialog-shared.component';
import {InitInformation} from "@models/init-information.interface";
import {ShipmentService} from "@services/shipment.service";

@Component({
  selector: 'regitsration-users-dialog',
  templateUrl: './registration-user-dialog.component.html'
})
export class RegistrationUserDialog implements OnInit {
  userRegitsrationForm: FormGroup;
  progress = false;
  possibleCountries: Array<{value: string; label: string}>;
  openWindow(href) {
    window.open(href, '');
    return false;
  }


  constructor(private userService: UserService,
              private _fb: FormBuilder,
              public dialogRef: MatDialogRef<RegistrationUserDialog>,
              public dialog: MatDialog,
              private handler: RequestsHandler,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private shipmentService: ShipmentService) { }

  ngOnInit() {
    this.userRegitsrationForm = this._fb.group({
      user: this._fb.group({
        name: ['', Validators.required],
        surname: ['', Validators.required],
        email: ['', Validators.required],
        phone: [''],
        invoice_country_code: [''],
        invoice_zip: [''],
        invoice_city: [''],
        invoice_address: [''],
      }),
    });
    this.shipmentService.getInitialData()
      .subscribe((data: InitInformation) =>
        this.possibleCountries = this.shipmentService.possibleCountries);
  }

  save() {
    this.progress = true;
    if (this.userRegitsrationForm.valid) {
      const controls = this.userRegitsrationForm.controls['user'];
      const data = {
        name:   controls['controls'].name.value,
        surname:   controls['controls'].surname.value,
        email:   controls['controls'].email.value,
        phone:   controls['controls'].phone.value,
        invoice_country_code:   controls['controls'].invoice_country_code.value,
        invoice_zip:   controls['controls'].invoice_zip.value,
        invoice_city:   controls['controls'].invoice_city.value,
        invoice_address:   controls['controls'].invoice_address.value,
      };

      this.userService.postUser(data)
        .catch((error): any => {
          this.progress = false;
          if (error.error.hasOwnProperty('email')) {
            this.userRegitsrationForm.controls['user']['controls'].email.status = 'invalid';
          }
          this.handler.handleError(error);
          return Observable.throw(new Error(error));
        })
        .subscribe(() => {
          this.progress = false;
          this.dialogRef.close('Yes!');
        });
    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.fieldsMustBeFilled' }});
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/registration-user-dialog/registration-user-dialog.component.ts